export default "__VITE_ASSET__29f0b1a4__"